import { render, staticRenderFns } from "./2Step.vue?vue&type=template&id=88d8742a&scoped=true&"
import script from "./2Step.vue?vue&type=script&lang=js&"
export * from "./2Step.vue?vue&type=script&lang=js&"
import style0 from "./2Step.vue?vue&type=style&index=0&id=88d8742a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d8742a",
  null
  
)

export default component.exports